import AppMessage from 'components/app-message';

export const ErrorMessage = () => {
  return (
    <AppMessage
      type="failure"
      isShow
      autoDismiss={false}
      onDismiss={() => {
        window.location.reload();
      }}
    >
      有東西出錯了，請點擊以重新整理
    </AppMessage>
  );
};
